import type { ChangeEvent, ForwardedRef } from 'react'
import { forwardRef } from 'react'
import { clamp, safeToNumber, formatNumber } from '@getcircuit/web-utils'

import { useControllableState } from '../../hooks'
import Input from '../Input/Input'
import type { NumberInputProps } from './types'

function NumberInput(
  {
    min,
    max,
    digits,
    value: valueProp,
    defaultValue: defaultValueProp,
    onNumberChange,
    ...rest
  }: NumberInputProps,
  ref: ForwardedRef<HTMLInputElement>,
) {
  const [value = min ?? '', setValue] = useControllableState<string | number>({
    prop: valueProp,
    defaultProp: defaultValueProp,
    onChange(nextValue: string | number) {
      onNumberChange?.(safeToNumber(nextValue))
    },
  })

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const clampedValue = clamp(
      safeToNumber(e.target.value) || 0,
      safeToNumber(min),
      safeToNumber(max),
    ).toString()

    if (clampedValue !== value) {
      setValue(clampedValue)
    }
  }

  return (
    <Input
      ref={ref}
      type="number"
      value={formatNumber(value, { digits })}
      onChange={handleChange}
      {...rest}
    />
  )
}

export default forwardRef(NumberInput)
